import { ThemeOptions } from '@material-ui/core/styles';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

/**
 * Applies global word-breaking to prevent overflow of long unbreakable text.
 */
export const applyGlobalWordBreak = <T extends ThemeOptions>(theme: T): T => {
  const globalWordBreak: CSSProperties = {
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
  };

  return {
    ...theme,
    overrides: {
      ...(theme.overrides ?? {}),
      MuiCssBaseline: {
        '@global': {
          '*': globalWordBreak,
          body: globalWordBreak,
        },
      },
    },
  };
};
